var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Chighchart ng-if=\"$ctrl.graphConfig\" config=\"$ctrl.graphConfig\"\u003E\u003C\u002Fhighchart\u003E";;return pug_html;};
module.exports = template;